import { useEffect, useMemo, useRef } from 'react';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useTableRefStore } from '../table-ref/index.tsx';

export const useTableAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [{ tableRef }] = useTableRefStore();

	const tableInitialised = useRef(false);
	const _columns = tableRef.current?.getColumnManager()?._columns;
	const columns = useMemo(() => _columns ?? [], [_columns]);

	useEffect(() => {
		if (!tableInitialised.current && columns.length > 0) {
			fireTrackAnalytics(createAnalyticsEvent({}), 'table init', {
				numberOfColumns: columns.length,
			});
			tableInitialised.current = true;
		}
	}, [columns.length, createAnalyticsEvent]);
};
